import { render } from "./ModalAviso.vue?vue&type=template&id=0270d597&scoped=true"
import script from "./ModalAviso.vue?vue&type=script&lang=js"
export * from "./ModalAviso.vue?vue&type=script&lang=js"

import "./ModalAviso.vue?vue&type=style&index=0&id=0270d597&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0270d597"]])

export default __exports__